// Matches bracketed variable references within a formula, e.g. [FIELD_A]
const VAR_REF_TOKEN = /\[([^\]]+)\]/g;

// Shared by PriceResFormulaContent and PriceResVarsList. Splits a formula into an ordered list of
// parts, tagging each bracketed token with its var code (e.g. [PROG:123] -> { text: '[PROG:123]', code: 'PROG:123' }).
export const parseFormulaParts = (formula) => {
  if (!formula) return [];

  const parts = [];
  let lastIndex = 0;
  const regex = new RegExp(VAR_REF_TOKEN);
  let match;
  while ((match = regex.exec(formula)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ text: formula.slice(lastIndex, match.index) });
    }
    parts.push({ text: match[0], code: match[1] });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < formula.length) {
    parts.push({ text: formula.slice(lastIndex) });
  }

  return parts;
};
